import React from 'react'

interface IconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Custom Target Arrow icon (filled state)
 * Based on Tabler icon, with custom filled variant
 */
export const TargetArrowIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" fill={color} />
    <path
      d="M12 7a5 5 0 1 0 5 5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 3.055a9 9 0 1 0 7.941 7.945"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6v3h3l3 -3h-3v-3z"
      fill={color}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9l-3 3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Custom Target Arrow icon (outline state)
 * Based on Tabler icon
 */
export const TargetArrowOutlineIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7a5 5 0 1 0 5 5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 3.055a9 9 0 1 0 7.941 7.945"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6v3h3l3 -3h-3v-3z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9l-3 3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Custom Workspace/Drawer icon (filled state)
 * Custom icon to match the design system
 */
export const WorkspaceFilledIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Top drawer */}
    <rect x="3" y="3" width="18" height="8" rx="2" fill={color} />
    {/* Top drawer handle */}
    <rect
      x="9"
      y="6"
      width="6"
      height="2"
      rx="1"
      fill="currentColor"
      opacity="0.3"
    />
    {/* Bottom drawer */}
    <rect x="3" y="13" width="18" height="8" rx="2" fill={color} />
    {/* Bottom drawer handle */}
    <rect
      x="9"
      y="16"
      width="6"
      height="2"
      rx="1"
      fill="currentColor"
      opacity="0.3"
    />
  </svg>
)

/**
 * Custom Workspace/Drawer icon (outline state)
 * Custom icon to match the design system
 */
export const WorkspaceOutlineIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Top drawer */}
    <rect
      x="3"
      y="3"
      width="18"
      height="8"
      rx="2"
      stroke={color}
      strokeWidth="2"
    />
    {/* Top drawer handle */}
    <line
      x1="9"
      y1="7"
      x2="15"
      y2="7"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    {/* Bottom drawer */}
    <rect
      x="3"
      y="13"
      width="18"
      height="8"
      rx="2"
      stroke={color}
      strokeWidth="2"
    />
    {/* Bottom drawer handle */}
    <line
      x1="9"
      y1="17"
      x2="15"
      y2="17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
